<section [ngClass]="{ 'awb-search-form': !showSearchButtonOutside }">
    <form [formGroup]="searchForm" (submit)="submit(searchForm)">
        <mat-form-field class="col-12 m-0">
            <mat-label id="search-awb-label">{{ searchAwbLabel }}</mat-label>
            <input
                id="search-awb-input"
                [imask]="{ mask: maskAwb }"
                formControlName="mawb"
                matInput
                type="text"
                class="input-awb"
                [placeholder]="searchAwbLabel"
                [readonly]="isLoading"
            />
            @if (!isCompleted && !showSearchButtonOutside) {
                <button type="submit" color="primary" mat-button matTextSuffix [disabled]="isLoading || disabled">
                    SEARCH
                </button>
            }
            @if (isCompleted && !showSearchButtonOutside) {
                <button
                    type="button"
                    mat-icon-button
                    [disabled]="isLoading"
                    (click)="cleanInput()"
                    class="me-2"
                    matIconSuffix
                >
                    <mat-icon>close</mat-icon>
                </button>
            }
            @if (!isLoading) {
                <mat-icon matIconPrefix>search</mat-icon>
            }
            @if (isLoading) {
                <mat-icon matIconPrefix>
                    <mat-spinner diameter="24" />
                </mat-icon>
            }
            <mat-error>
                <app-field-error [field]="'mawb'" [messageList]="formError['mawb']" />
            </mat-error>
        </mat-form-field>
        @if (!showStation && showSearchButtonOutside) {
            <button
                matButton="filled"
                type="submit"
                class="w-100 my-4"
                color="primary"
                [disabled]="isLoading || disabled"
            >
                {{ isLoading ? 'SEARCHING' : 'SEARCH' }}
                @if (isLoading) {
                    <mat-icon matIconPrefix>
                        <mat-spinner diameter="24" />
                    </mat-icon>
                }
            </button>
        }
    </form>
</section>
@if (showStation) {
    <div class="mt-3">
        <app-sprintpay-facility-locations (eventOnChange)="onSelectShipmentLocation($event)">
            <ng-template let-locationForm>
                <button
                    mat-flat-button
                    color="primary"
                    class="mt-3 w-100"
                    [disabled]="isLoading || locationForm.invalid"
                    (click)="redirectTo(locationForm.value?.location)"
                >
                    CONTINUE
                </button>
            </ng-template>
        </app-sprintpay-facility-locations>
    </div>
}
